import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService {

  constructor(private httpClientService:HttpClientService) { }

  async createUserNotification(notifications){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.UserNotification
    },notifications);
    return await firstValueFrom(observable);
  }

  async hasReaderNotification(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.UserNotification
    },id);
    return await firstValueFrom(observable);
  }
}
